import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './weather.json';

const Weather = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Weather vocabulary, climate terms, and forecasting language. B2 level grammar, reading, and speaking exercises."
            level="B2"
            title="Weather"
            image="/Images/extremeweather.webp"
            seoTitle="Free English Lesson Plans: Weather"
            seoDescription="Weather vocabulary, climate terms, and forecasting language. B2 level grammar, reading, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Weather;


